import React, { useEffect, useState } from "react";
import api from "../api";
import { Link } from "react-router-dom";

export default function Customers() {

  const [customers, setCustomers] = useState([]);

  const fetchCustomers = async () => {
    try {
      const res = await api.get("/customers");
      setCustomers(res.data);
    } catch {
      alert("Failed to load customers");
    }
  };

  const deleteCustomer = async (id) => {
    if (!window.confirm("Delete this customer?")) return;

    await api.delete(`/customers/${id}`);
    fetchCustomers();
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  return (
    <div className="container mt-3">

      {/* 🔥 CENTER WRAPPER */}
      <div className="mx-auto" style={{ maxWidth: "900px" }}>

        <h4 className="mb-3">👤 Customers</h4>

        {/* ================= DESKTOP TABLE ================= */}
        <div className="d-none d-md-block">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Company</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {customers.map((c) => (
                <tr key={c.id}>
                  <td>{c.user?.name}</td>
                  <td>{c.user?.email}</td>
                  <td>{c.company_name || "—"}</td>
                  <td>
                    <Link
                      to={`/customers/${c.id}/edit`}
                      className="btn btn-sm btn-warning me-2"
                    >
                      Edit
                    </Link>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deleteCustomer(c.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE CARDS ================= */}
        <div className="d-md-none">

          {customers.map((c) => (
            <div key={c.id} className="card p-2 mb-2 shadow-sm">

              <div className="d-flex justify-content-between">
                <strong>{c.user?.name}</strong>
                <span className="badge bg-secondary">
                  {c.company_name || "—"}
                </span>
              </div>

              <div className="small text-muted">
                {c.user?.email}
              </div>

              <div className="d-flex gap-2 mt-2">
                <Link
                  to={`/customers/${c.id}/edit`}
                  className="btn btn-sm btn-warning w-50"
                >
                  Edit
                </Link>

                <button
                  className="btn btn-sm btn-danger w-50"
                  onClick={() => deleteCustomer(c.id)}
                >
                  Delete
                </button>
              </div>

            </div>
          ))}

        </div>

        {/* EMPTY STATE */}
        {customers.length === 0 && (
          <div className="alert alert-info text-center mt-3">
            No customers found
          </div>
        )}

      </div>

    </div>
  );
}